// pages/departements/DeleteConfirmModal.jsx
import React, { useState } from 'react';
import api from '../../services/api';
import { X, AlertTriangle, Trash2 } from 'lucide-react';

export default function DeleteConfirmModal({ isOpen, onClose, onSuccess, departement }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen || !departement) return null;

  const handleDelete = async () => {
    setLoading(true);
    setError('');
    try {
      await api.delete(`/departements/${departement.ID_Departement}`);
      alert('Département supprimé avec succès');
      onSuccess();
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || 'Erreur lors de la suppression');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-5 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-base font-semibold text-red-600">⚠️ Supprimer le département</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">✕</button>
        </div>
        <div className="text-center py-2">
          <AlertTriangle size={48} className="mx-auto text-amber-500 mb-3" />
          <p className="text-gray-700 mb-2">Êtes-vous sûr de vouloir supprimer ce département ?</p>
          <p className="font-semibold text-gray-900">{departement.Nom_Departement}</p>
          {departement.NbServices > 0 && (
            <p className="text-xs text-red-500 mt-2">⚠️ {departement.NbServices} service(s) y sont rattachés.</p>
          )}
        </div>
        {error && <div className="mt-3 p-2 bg-red-50 text-red-500 text-sm rounded text-center">{error}</div>}
        <div className="flex gap-3 mt-6">
          <button onClick={onClose} className="flex-1 px-3 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm hover:bg-gray-200 transition">
            Annuler
          </button>
          <button onClick={handleDelete} disabled={loading} className="flex-1 px-3 py-2 bg-red-600 text-white rounded-lg text-sm hover:bg-red-700 transition disabled:opacity-50 flex items-center justify-center gap-2">
            <Trash2 size={14} /> {loading ? 'Suppression...' : 'Supprimer'}
          </button>
        </div>
      </div>
    </div>
  );
}